"use client";

import { useEffect, useState } from "react";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Icons } from "@/components/icons";

export const Testimonials = () => {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setTimeout(() => {
      if (api.selectedScrollSnap() + 1 === api.scrollSnapList().length) {
        setCurrent(0);
        api.scrollTo(0);
      } else {
        api.scrollNext();
        setCurrent(current + 1);
      }
    }, 4000);
  }, [api, current]);

  return (
    <div className="w-full bg-muted py-8 sm:py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col gap-6 sm:gap-8 lg:gap-10">
          <h2 className="font-regular text-left text-2xl tracking-tighter sm:text-3xl md:text-4xl lg:text-5xl">
            Happy Spot Clients
          </h2>
          <Carousel setApi={setApi} className="w-full">
            <CarouselContent>
              {Array.from({ length: 5 }).map((_, index) => (
                <CarouselItem className="md:basis-2/3 lg:basis-1/2" key={index}>
                  <div className="flex aspect-video h-full flex-col justify-between rounded-md bg-background p-4 sm:p-5 lg:p-6">
                    <Icons.User className="h-6 w-6 stroke-1 sm:h-7 sm:w-7 lg:h-8 lg:w-8" />
                    <div className="flex flex-col gap-3 sm:gap-4">
                      <div className="flex flex-col">
                        <h3 className="text-lg tracking-tight sm:text-xl">
                          Best decision
                        </h3>
                        <p className="mt-2 overflow-hidden text-sm text-muted-foreground sm:mt-3 sm:text-base">
                          Spot has been instrumental in helping us find the best
                          co-working space for our company as per our
                          requirements.
                        </p>
                        <p className="mt-2 overflow-hidden text-sm sm:mt-3 sm:text-base">
                          Booking and payments were a lot smoother with Spot.
                        </p>
                      </div>

                      <div className="flex items-center gap-2 text-xs text-muted-foreground sm:text-sm">
                        <Avatar className="h-8 w-8 sm:h-10 sm:w-10">
                          <AvatarImage src="/placeholder-user.jpg" />
                          <AvatarFallback>SK</AvatarFallback>
                        </Avatar>
                        <div>
                          <p className="font-medium">Shariq Khan</p>
                          <p className="text-xs sm:text-sm">
                            CEO, Startup Coworking
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
